import React from 'react'
import DatesTable from './components/DateTable/DatesTable'
import Title from '../../../components/Title/Title'
import { importantDates2026 } from '../../../common/constants/importantDates'

const ImportantDates2026page = () => {
    return (
        <>
            <Title>Important Dates</Title>
            <DatesTable array={importantDates2026} />
        </>
    )
}

export default ImportantDates2026page;
